import { render, staticRenderFns } from "./ModalCreateNew.vue?vue&type=template&id=a9b95b54&scoped=true&"
import script from "./ModalCreateNew.vue?vue&type=script&lang=js&"
export * from "./ModalCreateNew.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateNew.vue?vue&type=style&index=0&id=a9b95b54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b95b54",
  null
  
)

export default component.exports